import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';

import {
  findSimilarModalSetIsLoadingReducerType,
  findSimilarModalSetDataReducerType,
  findSimilarModalSetCurrentDbReducerType,
  findSimilarModalSetAvailableDatabasesReducerType,
  findSimilarModalSetDatabasesOrderReducerType,
} from './FindSimilarModalConstants';

export const initialState = Map({
  isLoading: false,
  data: null,
  currentDb: null,
  databasesOrder: null,
  availableDatabases: [],
});

const spec = {
  [findSimilarModalSetIsLoadingReducerType]: (state, action) => {
    const { isLoading } = action.payload;
    return state.set('isLoading', isLoading);
  },
  [findSimilarModalSetDataReducerType]: (state, action) => {
    const { data } = action.payload;
    return state.set('data', data);
  },
  [findSimilarModalSetCurrentDbReducerType]: (state, action) => {
    const { currentDb } = action.payload;
    return state.set('currentDb', currentDb);
  },
  [findSimilarModalSetDatabasesOrderReducerType]: (state, action) => {
    const { databasesOrder } = action.payload;
    return state.set('databasesOrder', databasesOrder);
  },
  [findSimilarModalSetAvailableDatabasesReducerType]: (state, action) => {
    const { availableDatabases } = action.payload;
    return state.set('availableDatabases', availableDatabases);
  },
};

export default createReducerBySpec(spec, initialState);
